/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  root: {
    margin: theme.spacing(2, 3, 3, 3)
  },
  appBarWrap: {
    display: 'flex',
    flexDirection: 'row',
    background: 'transparent !important'
  },
  backIcon: {
    boxSizing: 'border-box',
    width: Tokens.spacing['$sp-12'],
    height: Tokens.spacing['$sp-12'],
    color: theme.palette.text.primary,
  },
  headingAlignment: {
    color: theme.palette.text.primary,
    fontSize: Tokens.spacing['$sp-8-5'],
    marginBottom: Tokens.spacing['$sp-4'],
  },
  actionsMenuContainer: {
    flex: 1,
    color: theme.palette.text.primary,
  },
  emptyComponentWrapper: {
    height: '100px'
  },
  alertMsg: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: Tokens.spacing['$sp-3-5']
  },
  warningIcon: {
    marginRight: 10,
  },
  toolbarPanel: {
    padding: Tokens.spacing['$sp-3'],
  },
  actionButton: {
      marginRight: `${Tokens.spacing['$sp-2']} !important`,
    }
}));
